import { styled } from '@abyss/web/tools/styled';
import { V2Alert } from '@abyss/web/ui/Alert';

export const smartChoiceFlex = (
  isMobileScreen,
  isMemberSelectedHeader,
  isMixedResultsPage,
  memberChangeHeader,
  showChoosePCPHeader
) => ({
  right: isMobileScreen
    ? isMemberSelectedHeader && isMixedResultsPage
      ? '0px'
      : isMemberSelectedHeader || showChoosePCPHeader
      ? '50px'
      : '30px'
    : memberChangeHeader
    ? '50px'
    : '60px',
  bottom: isMobileScreen
    ? isMemberSelectedHeader
      ? '30px'
      : '0px'
    : memberChangeHeader
    ? isMemberSelectedHeader
      ? '4px'
      : '16px'
    : '18px',
  top: isMobileScreen ? (isMemberSelectedHeader ? 'auto' : '18px') : 'auto',
});

export const smartChoiceLinkStyle = (isMobileScreen, paddingBottom) => ({
  fontWeight: '600',
  marginTop: '-6px',
  '& .abyss-insert-element-after': {
    alignItems: 'flex-end',
    '& svg': { fill: '$error1' },
    marginLeft: isMobileScreen ? '-20px' : '-8px',
  },
  '&:hover::before': { display: 'none' },
  paddingBottom: paddingBottom ? '8px' : '0px',
});

export const coachmarkStyle = (checkMobileScreen) => ({
  '& button span': { color: '$gray7 !important' },
  '&.abyss-popover-trigger': {
    marginTop: '2px',
  },
  '& .abyss-popover-header h2': { fontSize: '16px' },
  '&.abyss-popover-content': {
    zIndex: '99999 !important',
    backgroundColor: '#4B4D4F',
    width: '400px',
    maxWidth: 'calc(100vw - 120px)',
    '@media (max-width: 600px)': {
      width: 'calc(100vw - 120px)',
      maxWidth: 'calc(100vw - 120px)',
    },
    '@media (max-width: 380px)': {
      width: 'calc(100vw - 160px)',
      maxWidth: 'calc(100vw - 160px)',
    },
    borderWidth: '0px',
    marginTop: checkMobileScreen('20px', '-6px'),
    marginLeft: '160px',
    marginRight: checkMobileScreen('10px', '25px'),
    borderRadius: '8px',
    '& svg': {
      fill: '#4B4D4F',
      height: '14px',
      width: '24px',
    },
    '.abyss-popover-close-button': {
      '& span': {
        backgroundColor: '#4B4D4F',
        color: '#FFFFFF !important',
        '&:hover, &focus': {
          backgroundColor: '#4B4D4F !important',
        },
      },
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
    '.abyss-psx-parcel-c-jbfunX': {
      width: '100%',
      maxWidth: '100%',
      paddingRight: '40px',
      boxSizing: 'border-box',
      '@media (max-width: 600px)': {
        paddingRight: '35px',
      },
      '@media (max-width: 380px)': {
        paddingRight: '30px',
      },
    },
    '.abyss-popover-content-container': {
      color: '#FFFFFF',
      fontSize: '14px',
      fontFamily: '$primary',
      fontWeight: '400px',
    },
    '.abyss-popover-title': {
      color: '#FFFFFF',
      fontSize: '18px',
      fontFamily: '$primary',
      fontWeight: '500px',
    },
  },
});

export const PreEffectiveAlertV2 = styled(V2Alert, {
  '& .abyss-alert-title': {
    lineHeight: '20px !important',
    marginTop: '2px',
    color: '#323333',
    fontSize: 'var(--abyss-psx-parcel-fontSizes-md) !important',
  },
  '& .abyss-alert-root': {
    height: '52px',
    borderTop:
      '1px solid var(--abyss-psx-parcel-colors-alert-color-border-root-info)',
    borderColor: 'var(--abyss-psx-parcel-colors-alert-color-border-root-info)',
    backgroundColor:
      'var(--abyss-psx-parcel-colors-alert-color-background-container-info)',
  },
  '& .abyss-alert-wrapper': {
    marginLeft: 'auto',
    maxWidth: '1200px',
    marginRight: 'auto',
    alignItems: 'center',
    gap: '4px',
  },
  '& .abyss-icon-symbol': {
    fontSize: '20px !important',
    paddingTop: '2px',
  },
  '& .abyss-alert-body-text': {
    paddingTop: '2px',
    lineHeight: '18px',
    fontSize: '14px',
    fontWeight: '400',
    color: '#323333',
  },
  '& .abyss-alert-text-container': {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '14px',
  },
  '@media (max-width: 593px)': {
    '& .abyss-alert-text-container': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
});
